import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=5a92aac9&scoped=true"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=5a92aac9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a92aac9",
  null
  
)

export default component.exports